import { Stack } from '@mui/material'
import type { FC } from 'react'
import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import approvalFlowsOperations from 'src/state/ducks/approvalFlows/operations'
import placesOperations from 'src/state/ducks/places/operations'
import type { RootState } from 'src/state/store'
import ApprovalFlowRow from './ApprovalFlowRow'
import IconRow from './IconRow'
import { NameRow } from './NameRow'
import PlaceRow from './PlaceRow'

const EditTemplateOption: FC = () => {
  const approvalFlows = useSelector(
    (state: RootState) => state.approvalFlowsState.approvalFlows.approvalFlows,
    shallowEqual,
  )
  const templatePlaceNodes = useSelector(
    (state: RootState) => state.placesState.placeNodes.nodes,
    shallowEqual,
  )

  const dispatch = useDispatch()

  useEffect(() => {
    approvalFlowsOperations.getApprovalFlows(dispatch)
    placesOperations.getPlaceNodes(dispatch)
  }, [dispatch])

  return (
    <Stack
      spacing={2}
      py={4}
      px={2}
      sx={{ maxWidth: 900, width: '100%', mx: 'auto' }}
    >
      <NameRow />
      <IconRow />
      {approvalFlows.length > 0 && <ApprovalFlowRow />}
      {/* type 的にはこれいつでも true だけど大丈夫？ */}
      {templatePlaceNodes && <PlaceRow />}
    </Stack>
  )
}

export default EditTemplateOption
